module.exports = __webpack_public_path__ + "img/my-activity.dd8ede0f.png";